// 讀取當前目錄下所有語言包並處理後export

/**
 * @description: object扁平化
 * @parameter {JSON}
 * @author: Mingzhen
 * @return {Object}
 */
const flat = (value) => {
    const result = {}
    const recurse = (cur, prop) => {
        if (Object(cur) !== cur) {
            result[prop] = cur;
        } else if (Array.isArray(cur)) {
            for (let i = 0, l = cur.length; i < l; i++)
                recurse(cur[i], prop + "[" + i + "]");
            if (l == 0)
                result[prop] = [];
        } else {
            let isEmpty = true;
            for (let p in cur) {
                isEmpty = false;
                recurse(cur[p], prop ? prop + "." + p : p);
            }
            if (isEmpty && prop)
                result[prop] = {};
        }
    }
    recurse(value, "");
    return result
}


const languageFiles = require.context('./', true, /.json$/)
export default languageFiles.keys().reduce((languages, modulePath) => {
    const moduleName = modulePath.replace(/^.\/(.*)\.json/, '$1');
    const value = languageFiles(modulePath);
    let ErrorCodeFlat = {};
    for (let key in value.ErrorCode) ErrorCodeFlat = { ...ErrorCodeFlat, ...value.ErrorCode[key] };
    value.ErrorCode = ErrorCodeFlat;
    languages["_" + moduleName] = flat(value);
    return languages
}, {})
